import { getData, postData } from "../common/Apicall";

export const createProductApi = (data) => {
  const { images, ...allData } = data;

  const formData = new FormData();

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      if (value !== null) formData.append(key, value);
    }
  }

  images.forEach((blob) => {
    formData.append("images", blob);
  });

  return postData("/api/v1/products/createProduct", formData, true);
};
export const allProductForStoreApi = (storeID) => {
  return postData("/api/v1/products/productByStoreID", { storeID });
};

export const allProductForStoreWebApi = (storeID) => {
  return postData("/api/v1/products/productByStoreIDWeb", { storeID });
};

export const allProductIdApi = (page , mainCategory, minPrice, maxPrice, subCategory, sortType, sellerTypes,rating) => {
  return postData(`/api/v1/products/getAllProducts?page=${page} ` , {mainCategory, minPrice, maxPrice ,
   subCategory , sortType, sellerTypes, rating} );
};

export const allProductByCategoryApi = (categoryID) => {
  return getData(`/api/v1/products/getAllProducts?categoryID=${categoryID}`);
};

export const allProductByTagsAPI = (tags) => {
  return postData(`/api/v1/products/getAllProducts?tags=${tags}`);
};

export const productIdApi = (productID) => {
  return postData("/api/v1/products/productByID", { productID });
};

export const wishlistApi = (userID) => {
  return postData("/api/v1/wishlist/getWishList", { userID });
};

export const toggleWishlistApi = (userID, productID, liked) => {
  return postData("/api/v1/wishlist/toggleWishlist", {
    userID,
    productID,
    liked,
  });
};

export const productSearchByStringApi = (productTitle) => {
  return postData("/api/v1/products/searchProductByString", { productTitle });
};
